import React from 'react';
import { Form } from "react-bootstrap";

export const ThemeHandler = (props) => {
    const mapOptions = () => {
        if (props.themes === undefined) {
            return null;
        }
        return props.themes.map((theme, index) => {
            return <option key={index + 1} value={theme.name}>{theme.name}</option>;
        });
    };

    return props.nodeType === "hub" || props.nodeType === "site" ? <Form.Group>
        <Form.Label>Themes</Form.Label>
        <Form.Control as="select" onChange={(ev) => props.onSelectTheme(ev.target.value)}
            value={props.selectedTheme}>
            <option key={0} value={0}>None</option>
            {mapOptions()}
        </Form.Control>
    </Form.Group> : null;
};


// WEBPACK FOOTER //
// ./src/components/tree/node/themeHandler.js